export default __webpack_public_path__ + "static/media/prescripcion.dffd25b7.svg";